<script>
	import { navigate } from "svelte-navigator";

	import { currentPage } from "../stores/pageStore";
	import model from "../stores/modelStore";

	import PrimaryButton from "./buttons/PrimaryButton.svelte";
	import PreviousButton from "./buttons/PreviousButton.svelte";

	export let showPrevious = true;
	export let showNext = true;
	export let disablePrevious = false;
	export let disableNext = false;
	export let nextPageLabel = "Next";

	let loading = false;
	let nextBtnDisabled = null;
	let previousBtnDisabled = null;

	export const buttons = {
		unblock() {
			loading = false;
			nextBtnDisabled = null;
			previousBtnDisabled = null;
		},

		blockNext() {
			loading = true;
			nextBtnDisabled = true;
			previousBtnDisabled = true;
		},

		blockPrevious() {
			nextBtnDisabled = true;
			previousBtnDisabled = true;
		},

		next(nextPage) {
			if (!nextPage) {
				nextPage = $currentPage.nextPage;
				if (typeof $currentPage.nextPage === "function") {
					nextPage = $currentPage.nextPage($model);
				}
			}
			navigate(nextPage);

			window.scrollTo({ top: 0, behavior: "smooth" });
		},

		previous() {
			buttons.blockPrevious();

			let previousPage = $currentPage.previousPage;
			if (typeof previousPage === "function") {
				previousPage = $currentPage.previousPage($model);
			}

			navigate(previousPage);

			buttons.unblock();
		}
	};
</script>

{#if !$model.surveyComplete}
	<div class="btn-wrap" class:single={showPrevious || showNext}>
		{#if showPrevious}
			<div class="me-2">
				<PreviousButton
					disabled={disablePrevious || previousBtnDisabled || $model.surveyComplete}
					type="button"
					on:click={buttons.previous}>
				</PreviousButton>
			</div>
		{/if}

		{#if showNext}
			<div>
				<PrimaryButton
					{loading}
					class="btn-page-nav"
					disabled={disableNext || nextBtnDisabled || $model.surveyComplete}
					type="submit">
					{nextPageLabel}
				</PrimaryButton>
			</div>
		{/if}
	</div>
{/if}

<style>
	.btn-wrap {
		display: flex;
		justify-content: center;
	}

	.btn-wrap.single {
		display: flex;
		justify-content: center;
	}

	:global(.btn-page-nav) {
		min-width: 240px;
		text-align: left;
	}
</style>
